function siteUrl(uri, query) {
	if (typeof uri === 'string' || Array.isArray(uri)) {
		let baseUrl = '';
		if (zweConfig && zweConfig.base_url) {
			baseUrl = zweConfig.base_url;
		}
		if (uri === '') {
			return baseUrl;
		}

		let absoluteUri = typeof uri === 'string' ? uri : uri.join('/');

		if (absoluteUri.indexOf('/') !== 0 && baseUrl.lastIndexOf('/') !== baseUrl.length - 1) {
			absoluteUri = `/${absoluteUri}`;
		}

		let url = `${baseUrl}${absoluteUri}`;
		if (query) {
			url = `${url}?${query}`;
		}

		return url;
	}

	throw new Error(`URI type not supported!`);
}

module.exports = siteUrl;
